<template>
    <div class="wrap login-wrap">
        <div class="logo-wrap">
            <img src="@/assets/img/logo_beta.png" class="w-270px" alt="better and better">
        </div>
        <div class="bnb-btn">
            <button class="active" @click="showApp()">앱 열기</button>
        </div>
    </div>
</template>
<script>
    export default {
        name :'landing',
        data: () => ({
            uri : "",
            idx : ""
        }),
        mounted() {
            let query = window.location.search;
            let param = new URLSearchParams(query);
            this.uri = param.get("uri");
            this.idx = param.get("idx");
        },
        methods: {
            showApp(){
                let targetUrl = "";
                if(this.uri == ""){
                    targetUrl = `https://bnb-user-link.carrotglobal.com`;
                }else{
                    if(this.idx == ""){
                        targetUrl = `https://bnb-user-link.carrotglobal.com/${this.uri}`;
                    }else{
                        targetUrl = `https://bnb-user-link.carrotglobal.com/${this.uri}/${this.idx}`;
                    }
                }
                // setTimeout((function(){
                //     window.open(targetUrl);
                // },1500)

                setTimeout(function(){
                    window.open("https://apps.apple.com/us/app/spac/id1225076497");
                },1500)
                location.href = targetUrl;
            }
        }
    }
</script>